import ElementPlus from 'element-plus';
import { ElLoading } from 'element-plus'
import {loadingConfig} from './config.js' //全局的一个基本参数配置
import {reactive,ref} from 'vue'

var loading = null ;

let process = {};//异步加载控制对象
const loadingShow = ($config=null) => {
	if($config?.url){
		process[$config?.url]=false;
		loading=ElLoading.service(loadingConfig);
	}
}

const loadingHide = ($response=null) => {
	if($response?.config){
		process[$response.config.url]=true;
		let has=true;
		for(let key  in process){
		    if(!process[key]){
				has=false;
			}
		}
		if(has==true){
			loading.close();
			process={};
		}
	}
}

const loadingObj={
	loadingShow,
	loadingHide
}

export default loadingObj